angular.module('wbFilters')
  .filter('percent', () => (input, precision) => {
    if (precision == null) { precision = 1; }
    const percentedNumber = new Number(input * 100).toFixed(precision);
    if (isNaN(percentedNumber)) { return 'N/A'; } else { return percentedNumber + '%'; }
  });
